import React from 'react';
import AppLayout from '../AppLayout';
import InputText from '../InputText';
import moment from 'moment';
import Loader from '../Loader';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getGenerator, getGeneratorDetails, storeGenerator } from '../../Api';

// const ipcRenderer = window.ipcRenderer;
class CLottery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            id: "",
            date: moment().format('YYYY-MM-DD'),
            phone: '',
            comment: '',
            opciones: 1,
            cifras: 1,
            update: false,
            numbers: [],
            show: false,
            texto: '',
        }
    }
    componentDidMount() {
        const { id } = this.props.match.params;
        if (id) {
            getGenerator({ token: this.props.usuario.token, params: { id } })
                .then((data = {}) => {
                    if (Object.keys(data).length > 0) {
                        this.setState({
                            ...data,
                            id,
                            date: moment(data.date.split('T')[0]).format('YYYY-MM-DD'),
                            update: true
                        })
                    } else {
                        this.setState({ update: false })
                    }
                })
        }
    }

    save() {
        try {
            const { date, opciones, cifras, phone = '', comment = '' } = this.state;
            this.getTotal(cifras, opciones)
            if (phone.length > 0 && comment.length > 0) {
                this.setState({ show: true });
                storeGenerator({ date, opciones, cifras, phone, comment }, this.props.usuario.token).then(data => {
                    const { history } = this.props
                    history.push('/generators');
                    this.setState({ show: false });
                }).catch(error => {
                    this.setState({ show: false });
                    alert(error)
                })
            }
        } catch (error) {
            alert(error)
        }
    }

    getTotal(cifras, opciones) {
        let end = '';

        for (let index = 0; index < cifras; index++) {
            end += '9';
        }
        const total = parseInt(end) + 1;
        if (total % opciones !== 0) {
            throw new Error(`No es posible crear boletos uniformes con ${opciones} opciones y ${cifras} cifras. El total (${total}) no es divisible de manera equitativa entre las opciones.
          `);
        }
        return total;
    }

    filter(text) {
        let tickets = this.state.all_tickets
        if (text.trim().length > 0) {
            tickets = this.state.all_tickets.filter(t => {
                return t.opciones.join().include(text) || t.qr.include(text)
            })
        }
        this.setState({ tickets })
    }

    render() {
        const { error, update } = this.state;
        return (
            <AppLayout title={""} loader={this.state.show}>
                <div className="box box-primary">
                    <div className="box-header with-border">
                        <h3 className="box-title">Archivo</h3>
                    </div>
                    <div className="box-body">
                        <div className="row">
                            <div className="col-md-3">
                                <InputText
                                    value={this.state.date}
                                    error={error.date}
                                    placeholder={""}
                                    label={"Fecha sorteo"}
                                    onChange={(event) => { this.setState({ "date": event.target.value }) }}
                                    type={"date"}
                                />
                            </div>
                            <div className="col-md-3">
                                <InputText
                                    value={this.state.opciones}
                                    error={error.opciones}
                                    placeholder={""}
                                    label={"Opciones"}
                                    onChange={(event) => { this.setState({ "opciones": event.target.value }) }}
                                    type={"range"}
                                    min={1}
                                    max={10}
                                    comment={this.state.opciones}
                                    className='custom-range'
                                />
                            </div>
                            <div className="col-md-3">
                                <InputText
                                    value={this.state.cifras}
                                    error={error.cifras}
                                    placeholder={""}
                                    label={"Cifras"}
                                    onChange={(event) => { this.setState({ "cifras": event.target.value }) }}
                                    type={"range"}
                                    min={1}
                                    max={5}
                                    comment={this.state.cifras}
                                    className='custom-range'
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <InputText
                                    value={this.state.phone}
                                    error={error.phone}
                                    placeholder={""}
                                    label={"Telefono"}
                                    onChange={(event) => { this.setState({ "phone": event.target.value }) }}
                                />
                            </div>
                            <div className="col-md-3">
                                <InputText
                                    value={this.state.comment}
                                    error={error.comment}
                                    placeholder={""}
                                    label={"Comentario"}
                                    onChange={(event) => { this.setState({ "comment": event.target.value }) }}
                                />
                            </div>
                        </div>
                    </div>
                    <Loader show={this.state.show} />
                    <div className="box-footer">
                        {!this.props.readOnly && (
                            <button
                                className="btn btn-primary"
                                onClick={(event) => { this.save() }}
                            >
                                Guardar
                            </button>
                        )}
                    </div>
                </div>
                {this.state.update && <div className="row">
                    <div className="col-xs-12">
                        <div className="box">
                            <div className="box-header">
                                <h3 className="box-title">Boletos</h3>
                                <div className="box-tools">
                                    <div className="input-group input-group-sm hidden-xs" style={{ width: "150px" }}>
                                        <input
                                            type="text"
                                            name="table_search"
                                            className="form-control pull-right"
                                            value={this.state.texto}
                                            onChange={e => { this.setState({ texto: e.target.value }) }}
                                            placeholder="Buscar"
                                        />
                                        <div className="input-group-btn">
                                            <button className="btn btn-default" onClick={(event) => {
                                                getGeneratorDetails({
                                                    token: this.props.usuario.token,
                                                    params: { id: this.state.id, number: this.state.texto.toLocaleLowerCase() }
                                                }).then((list = []) => {
                                                    this.setState({
                                                        tickets: list
                                                    })
                                                })
                                            }}>
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="box-body table-responsive no-padding">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Numeros</th>
                                            <th>qr</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.tickets && this.state.tickets.map(t => {
                                            return (<tr key={t._id}><td>{t.numbers}</td><td>{t.qr}</td></tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </div>
                </div>
                }
            </AppLayout>
        )
    }
};

const mapStoreToProps = (state, props) => {
    return {
        ...props,
        usuario: state.usuario,
        lotteries: state.lotteries,
        marketplaces: state.marketplaces
    }
}
export default withRouter(connect(mapStoreToProps)(CLottery));